import { createSlice } from '@reduxjs/toolkit';
import { THEME_DEFAULTS } from 'views/V2/Medallion/helper/constants';

const initialState = {
    nanoid: null,
    name: '',
    draft: { config: THEME_DEFAULTS, logo: null },
    initial: { config: THEME_DEFAULTS, logo: null },
    discardModal: { isOpen: false, pendingLocation: null },
};

export const themesSlice = createSlice({
    name: 'themes',
    initialState,
    reducers: {
        // Called on mount and again after a successful save, so `initial`
        // always reflects what the server actually holds.
        resetDraft: (state, action) => {
            const { nanoid, name, config, logo } = action.payload;
            state.nanoid = nanoid;
            state.name = name;
            state.draft = { config, logo };
            state.initial = { config, logo };
        },
        setName: (state, action) => {
            state.name = action.payload;
        },
        setDraftField: (state, action) => {
            const { field, value } = action.payload;
            state.draft.config[field] = value;
        },
        setDraftLogo: (state, action) => {
            state.draft.logo = action.payload;
        },
        revertDraft: (state) => {
            state.draft = state.initial;
        },
        commitDraft: (state) => {
            state.initial = state.draft;
        },
        openDiscardModal: (state, action) => {
            state.discardModal = { isOpen: true, pendingLocation: action.payload };
        },
        closeDiscardModal: (state) => {
            state.discardModal = { isOpen: false, pendingLocation: null };
        },
    },
});

export const {
    resetDraft,
    setName,
    setDraftField,
    setDraftLogo,
    revertDraft,
    commitDraft,
    openDiscardModal,
    closeDiscardModal,
} = themesSlice.actions;

export default themesSlice.reducer;
